function hasThrowOfHeight(pp, n) {
    for (const p of pp.patterns) {
        for (const b of p.beats) {
            for (const bt of b.beatThrows) {
                for (const mp of bt.multiplexes) {
                    if (mp.height === n) {
                        return true;
                    }
                }
            }
        }
    }
    return false;
}
export function getCadenceLimits(pp) {
    const ret = {
        dwellF: [0.1, 0.9],
        shiftF: [0.1, 0.9],
    };
    if (hasThrowOfHeight(pp, 1)) {
        ret.shiftF = [0.5, 0.5];
        ret.dwellF = [0.1, 0.4];
    }
    return ret;
}
